import React, { createContext, useContext, useState, useCallback } from 'react'

type DetailModalContextValue = {
  isDetailModalOpen: boolean
  setDetailModalOpen: (open: boolean) => void
}

const DetailModalContext = createContext<DetailModalContextValue>({
  isDetailModalOpen: false,
  setDetailModalOpen: () => {},
})

export function DetailModalProvider({ children }: { children: React.ReactNode }) {
  const [isDetailModalOpen, setDetailModalOpen] = useState(false)
  const setOpen = useCallback((open: boolean) => setDetailModalOpen(open), [])
  return (
    <DetailModalContext.Provider value={{ isDetailModalOpen, setDetailModalOpen: setOpen }}>
      {children}
    </DetailModalContext.Provider>
  )
}

export function useDetailModalOpen() {
  return useContext(DetailModalContext)
}
